forumPageCtrl.$inject = ['$stateParams', 'LangUtils'];

export default function forumPageCtrl($stateParams, LangUtils) {
    const vm = this;
}
